import React from 'react';
import { ReactSVG } from 'react-svg';

import './DeliveryInformation.scss';

const DeliveryInformation = () => (
  <section id='delivery-information-section'>
    <div className='delivery-info'>
      <div className='info-item'>
        <ReactSVG
          src='/images/pdp/delivery-cart.svg'
        />
        <div>
          <h3>Free delivery</h3>
          <p>on orders over £35</p>
        </div>
      </div>
      <div className='info-item'>
        <ReactSVG
          src='/images/pdp/back-arrow-delivery.svg'
        />
        <div>
					<h3>Free returns</h3>
					<a
						href='https://joshwoodcolour.com/faq#money-back-guarantee'
            target='_blank'
            rel='noopener noreferrer'
					>
						find out more
					</a>
				</div>
			</div>
		</div>
  </section>
)


export default DeliveryInformation;